var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRudeReaction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3036_32514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z",
    fill: "#F94343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7866 27.8296C12.6712 27.8296 12.5541 27.799 12.4478 27.7352C12.1363 27.5476 12.0358 27.1434 12.2234 26.8319C13.0159 25.5155 14.1378 24.4134 15.4679 23.6449C16.8396 22.8524 18.4063 22.4336 19.9991 22.4336C21.592 22.4336 23.1587 22.8524 24.5304 23.6449C25.8605 24.4134 26.9824 25.5155 27.7749 26.8319C27.9625 27.1434 27.862 27.5476 27.5505 27.7352C27.239 27.9229 26.8344 27.8221 26.6471 27.5109C25.2296 25.1561 22.7444 23.75 19.9995 23.75C17.2545 23.75 14.7694 25.1558 13.3515 27.5109C13.2279 27.7157 13.0101 27.8296 12.7866 27.8296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.731 18.9308C25.6763 18.9308 26.4425 18.1646 26.4425 17.2193C26.4425 16.2741 25.6763 15.5078 24.731 15.5078C23.7858 15.5078 23.0195 16.2741 23.0195 17.2193C23.0195 18.1646 23.7858 18.9308 24.731 18.9308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2701 18.9308C16.2153 18.9308 16.9816 18.1646 16.9816 17.2193C16.9816 16.2741 16.2153 15.5078 15.2701 15.5078C14.3249 15.5078 13.5586 16.2741 13.5586 17.2193C13.5586 18.1646 14.3249 18.9308 15.2701 18.9308Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3036_32514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRudeReaction);
export default __webpack_public_path__ + "static/media/rudeReaction.885314bb26642ec99714776058a7ff38.svg";
export { ForwardRef as ReactComponent };